(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qka-color-swatches"] && !Shopify.designMode) return;
  try {
    class QkaColorSwatches extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.owner = this.closest('qka-product-card, variant-picker');
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-color]');
      if (!button) return;
      const select = this.colorSelect();
      if (!select) return;
      select.value = button.dataset.color;
      if (this.owner?.tagName === 'VARIANT-PICKER') {
        const variants = JSON.parse(this.querySelector('script').textContent);
        const selects = Array.from(this.owner.querySelectorAll('select'));
        const exact = variants.find(variant => variant.options.every((value, index) => value === selects[index].value));
        if (!exact) {
          const index = Number(this.dataset.optionIndex);
          const fallback = variants.find(variant => variant.available && variant.options[index] === select.value)
            || variants.find(variant => variant.options[index] === select.value);
          if (fallback) selects.forEach((input, position) => {
            input.value = fallback.options[position];
            Array.from(input.options).forEach(option => option.toggleAttribute('selected', option.value === input.value));
          });
        }
      }
      select.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    });
    this.owner?.addEventListener('change', () => this.sync());
    this.sync();
  }
  colorSelect() {
    return this.owner?.querySelectorAll('select')[Number(this.dataset.optionIndex)];
  }
  sync() {
    const select = this.colorSelect();
    if (!select) return;
    this.querySelectorAll('button[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === select.value)));
  }
}
if (!customElements.get('qka-color-swatches')) customElements.define('qka-color-swatches', QkaColorSwatches);
  } catch(e) { console.error(e); }
})();

})();
